<section class="grey-M" [style.width]="(type=='read' || type=='edit') ? '497px' : '429px'">
    <div class="dim1" [style.height]="(type=='read' || type=='edit') ? '114px' : ' 54px'" [ngClass]="(type=='read' || type=='edit')?'padLR20':''" style="padding-top: 1px">
        <div *ngIf="type=='add' && pageTitle" class="plabel" [dir]="textDir">{{pageTitle}}</div>
        <div *ngIf="type=='add' && !pageTitle" class="plabel">{{'Add new partner' | translate}}</div>
        <div *ngIf="type == 'edit' ">
            <div class="txtLeft">
                <app-ctl-logo-upload image=true bucket='partner' type='logo' wrapperClass="ctlInputFile"
                    imgClass="round"
                    [imgSource]="this.partnerForm.get('logo').value?.url || 'assets/images/upload_image.png'"
                    [myForm]=this.partnerForm>
                </app-ctl-logo-upload>
            </div>
            <div class="partnerLabel pad15">
                <ng-container>
                    <div class="head-one">{{partnerListData?.partner?.name}}</div>
                </ng-container>
                <ng-container
                    *ngIf="(this.partnerListData?.partner?.logo?.url || this.partnerForm.get('logo').value?.url)">
                    <a class="removePhoto"
                        (click)="removePhoto();">{{'Remove photo' | translate}}</a>
                </ng-container>

            </div>

        </div>

        <div *ngIf="type=='read'" class="sm-12">
            <div class="sm-10 spaceBtwn">
               

                <div class="label1 flexStart">
                    <ng-container *ngIf="type=='read'">
                       <div> <img *ngIf="partnerListData?.partner?.logo?.url"
                            [src]="partnerListData?.partner?.logo?.url?.replace('<FILEBASEURL>', environment.msdpAPIBaseURL)"
                            class="img-circle img-responsive logoRead" alt=''>
                        <img *ngIf="!partnerListData?.partner?.logo?.url" src='assets/images/upload_image.png'
                            class="img-circle img-responsive imgRead" alt=''>
                            
                        </div>
                   <div class="pad15">
                        <div class="head-one">{{partnerListData?.partner?.name}}</div>
                        <div class="head-two padT2">{{partnerListData?.type}}</div>
                    </div>
                    </ng-container>

                </div>
            <div *ngIf="loggedInUser.role?.name==='GeneralAdmin' || loggedInUser.role.lead">
                <div *ngIf="partnerListData?.type!=='Lead Partner' && type=='read'" class='spaceBtw1'>
                <!-- [ngClass]="partnerListData?.partner?.active ? 'spaceBtw1' : 'spaceBtw2'" > -->
                    <div class="marT8">
                        <label *ngIf="partnerListData?.partner?.active === true"
                            class="labeltxt disabled padT5">{{'Archived' | translate}}</label>
                        <label *ngIf="partnerListData?.partner?.active !== true"
                            class="labeltxt  padT5">{{'Archived' | translate}}</label>
                    </div>
                    <div class="padL5">
                        <label class="switch">
                            <input type="checkbox" id="usrStatus" #usrstatus
                                [checked]="partnerListData?.partner?.active === true"
                                (change)="confirmEnableDisable($event.target.checked)" [dir]="textDir">
                            <i class="ball"></i>
                            <span data-enabled="Active" data-disabled="Archived" style="display: none;"></span>
                        </label>
                    </div>
                    <div class="marT8">
                        <label *ngIf="partnerListData?.partner?.active  === true"
                            class="padL5 labeltxt  padT5">{{'Active' | translate}}</label>
                        <label *ngIf="partnerListData?.partner?.active  !== true"
                            class="padL5 labeltxt disabled padT5">{{'Active' | translate}}</label>
                    </div>
                </div>
            </div>

            </div>
        </div>
    </div>

    <div>

        <div class="clearfix"></div>
        <div [hidden]="type!='read'" class="padT10" [ngClass]="type==='read'? 'white hgt-160': ''" [dir]="textDir">
            <div class="form-inline">
                <label class="labelwid form-label1">{{'Name' | translate}}</label>
                <div class="form-div">
                    {{ partnerListData?.partner?.name}}
                </div>
            </div>
            <div class="form-inline">
                <label class="labelwid form-label1">{{'Email address' | translate}}</label>
                <div class="form-div">
                    {{ partnerListData?.partner?.email | truncate: 30 : "..."}}
                </div>
            </div>
            <div class="form-inline">
                <label class="form-label1">{{'Status' | translate}}</label>
                <div class="form-div">
                    {{ partnerListData?.type}}
                </div>

            </div>
            <div class="clearfix"></div>
           <!--  <div class="sm-12 marT20 view marL10"
                *ngIf="loggedInUser.role.name!='GlobalAdmin' && loggedInUser.role.name!='ProjectAdmin'">
                <span style="font-size: 12px; opacity: 0.9;">* Lead Project Administrators can archive and edit Partners. To edit the Lead Partner please place
                    a request with the Global Administrator.</span>
            </div>
            <div class="sm-12 marT20 marL10 view" *ngIf="loggedInUser.role.name=='ProjectAdmin' && !loggedInUser.role.lead">
                <span style="font-size: 12px; opacity: 0.9;">* To edit Partner details place a request with the Lead Project Administrator
                </span>
            </div> -->
            <div class="clearfix"></div>
            <div class="sm-12 marT20 view"></div>
        </div>
    </div>
</section>

<ng-container *ngIf="type!=='read'">
    <form class="form-horizontal white padT5" [ngClass]="( type === 'edit')?'hgt-160':'hgt-205'" enctype="multipart/form-data" [formGroup]="partnerForm" [dir]="textDir">
        <div class="form-inline" *ngIf="type === 'add' || type === 'edit'">
            <label class="labelwid form-label1">{{'Partner name' | translate}}</label>
            <div class="form-div" [ngClass]="textDir">
                <input type=text class="form-control" [ngClass]="( type === 'edit')?'txtW-lg':'txtW'" min-chars=1 maxlength=50 accept-user-input=true
                    placeholder="Ex. Ministry of Education, Sudan" formControlName="name" required [dir]="textDir"/>
            </div>
        </div>
        <div class="form-inline flexStart" *ngIf="type === 'add' || type === 'edit'">
            <div class="form-div">
                <label class="labelwid form-label1">{{'Email address' | translate}}</label>
            </div>
            <div class="form-div">
                <div [ngClass]="textDir">
                    <input type="email" class="form-control" [ngClass]="type === 'edit' ?'txtW-lg':'txtW'" id="web" placeholder="Ex. primary.contact@partner.org"
                    formControlName="email" required (change)="formChanged($event)" [dir]="textDir"/>
                </div>
                <div *ngIf="this.partnerForm.controls.email.invalid &&
                    this.partnerForm.controls.email.value"
                    class="alert alert-danger padT5" [dir]="textDir" style="height: 20px;">
                    <div *ngIf="this.partnerForm.controls.email.errors &&
                        this.partnerForm.controls.email.errors.pattern">
                        {{'Partner email address is not valid.' | translate}}
                    </div>
                </div>
            </div>
        </div>
        <label *ngIf="type === 'add'" class="labelwid form-label1 logoLabel">{{'Logo (optional)' | translate}}</label>
        <div *ngIf="type === 'add'" class="form-inline" class="logoDim" [dir]="textDir">

            <div class="form-div" [ngClass]="textDir=='ltr'?'marL20':'marR20'">
                <app-ctl-logo-upload image=true bucket='partner' type='logo' wrapperClass="ctlInputFile"
                    imgClass="round"
                    [imgSource]="this.partnerForm.get('logo').value?.url || 'assets/images/upload_image.png'"
                    [myForm]=this.partnerForm>
                </app-ctl-logo-upload>
            </div>
        </div>
        <div *ngIf="type == 'edit'" class="form-inline">
            <label class="form-label1">{{'Status' | translate}}</label>
            <div class="form-div">
                <label class="labeltxt">{{partnerType}}</label>
            </div>
        </div>
    </form>
</ng-container>